/**
 * Comparação de texto para BUSCA digitada: minúsculas e sem acento.
 *
 * Existe porque a busca de colaborador passou a ser local (15/09/2026): o backend já ignorava
 * acento, e um `includes` cru faria "joao" deixar de achar "João Silva" — o usuário digitaria o
 * nome certo e a lista diria que não existe ninguém.
 *
 * `removerAcentos` é a primitiva: as telas que montam chave a partir de rótulo (Tags de Esteira,
 * Checklist, classe do veículo, as DREs do Contac) passaram a usá-la na at-95, em vez de repetir o
 * `normalize('NFD')` à mão.
 */
export function removerAcentos(texto: string | null | undefined): string {
  return (texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '');
}

export function normalizarParaBusca(texto: string | null | undefined): string {
  return removerAcentos(texto).toLowerCase().trim();
}

/** `texto` contém `termo`, ignorando acento e caixa. Termo vazio casa com tudo. */
export function casaComBusca(texto: string | null | undefined, termo: string): boolean {
  const alvo = normalizarParaBusca(termo);
  return alvo.length === 0 || normalizarParaBusca(texto).includes(alvo);
}
